import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Button, Dropdown, DropdownCard, DropdownContent } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { MediaLibraryStore } from 'widgets/MediaLibrary/store/mediaLibraryStore'
import { MediaLibrarySelectMode, MediaLibraryVariant } from 'widgets/MediaLibrary/types/types'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import { useRinglessMessageFieldContext } from 'widgets/MessageFormFields/RinglessMessageField/context/ringlessMessageFieldContext'
import styles from './styles.module.scss'

type IRinglessMessageFieldActionsProps = {
  dropdownWidth?: number
}

export const RinglessMessageFieldActions = observer(
  ({ dropdownWidth }: IRinglessMessageFieldActionsProps) => {
    const {
      handleRecordAudio,
      handleTextToSpeech,
      onAddAttachmentAudio,
      clearError,
      mediaLibraryConfiguration,
    } = useRinglessMessageFieldContext()
    const entities = useEntitiesContext()
    const presentationStore = usePresentationModeContext()

    const [mediaLibraryStore] = useState(
      () =>
        new MediaLibraryStore(
          {
            mediaLibraryVariant: MediaLibraryVariant.RinglessSelect,
            onAddAttachment: onAddAttachmentAudio,
            selectMode: MediaLibrarySelectMode.Single,
            ...mediaLibraryConfiguration,
          },
          entities,
          presentationStore
        )
    )

    return (
      <div className={styles.wrap}>
        <Dropdown
          triggerComponent={(open) => (
            <Button
              fullWidth
              text={'Add Audio'}
              iconProps={{ icon: 'add' }}
              size={'medium'}
              contained={'secondary'}
              iconRightProps={{
                icon: open ? 'chevronUp' : 'chevronDown',
                className: styles.addRightIcon,
              }}
            />
          )}
          width={dropdownWidth}
          placement={'bottom-start'}
          customComponent={(onCloseMenu) => (
            <DropdownContent width={dropdownWidth}>
              <DropdownCard
                item={{
                  id: 'upload',
                  label: 'Upload or select',
                  iconL: 'plusCircle',
                  ariaLabel: 'uploadOrSelectAudio',
                }}
                onChange={() => {
                  onCloseMenu()
                  clearError()
                  mediaLibraryStore.handleOpenMediaLibraryModal()
                }}
              />
              <DropdownCard
                item={{
                  id: 'record',
                  label: 'Record Audio',
                  iconL: 'microphone',
                  ariaLabel: 'recordAudio',
                }}
                onChange={() => {
                  onCloseMenu()
                  handleRecordAudio()
                }}
              />
              <DropdownCard
                item={{
                  id: 'speech',
                  label: 'Text to Speech',
                  iconL: 'lineType',
                  ariaLabel: 'textToSpeech',
                }}
                onChange={() => {
                  onCloseMenu()
                  handleTextToSpeech()
                }}
              />
            </DropdownContent>
          )}
        />
      </div>
    )
  }
)
